// extracted by mini-css-extract-plugin
export default {"button":"PopUpCreateUser_button__sTdwa","buttonSave":"PopUpCreateUser_buttonSave__Nk3yH","popBox":"PopUpCreateUser_popBox__BvHyq","popLeft":"PopUpCreateUser_popLeft__njj3-"};